import React from 'react';
import {connect} from "react-redux";
import {List, ListItem} from 'material-ui/List';
import moment from './../../../../shared/utils/moment_fr';
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import AddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import Checkbox from 'material-ui/Checkbox';
import FormationForm from './comps/FormationForm';
import AuthService from './../../../../../services/AuthService';
import {getFormations} from "../../../../../actions/entreprise/actions_entreprise_entretien";
import Alert from "../../../../shared/utils/Alert";

class Page2 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false
        };
        this.Auth = new AuthService();
        this.fetchFormations = this.fetchFormations.bind(this);
        this.handleFormationsValidation = this.handleFormationsValidation.bind(this);
    }

    fetchFormations() {
        const id_entretien = this.props.entretienHeader.id;
        const id_salarie = this.props.entretienHeader.id_salarie;
        this.props.dispatch(getFormations(id_entretien, id_salarie));
    }

    componentDidMount() {
        if (this.props.entretienHeader && this.props.entretienHeader.id)
            this.fetchFormations();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.entretienHeader !== this.props.entretienHeader)
            this.fetchFormations();
    }

    handleFormationsValidation(id_formation, isValidated) {
        const id_entretien = this.props.entretienHeader.id;
        this.Auth.fetch('/salarie/formation/validation',
            {
                method: 'post',
                data: {
                    id_entretien: id_entretien,
                    id_formation: id_formation,
                    validated: isValidated
                }
            }).then(x => this.fetchFormations());
    }

    render() {
        const allFormations = this.props.formations;
        return (
            <div className={'row justify-content-md-center'}>
                <div className='col col-sm-10'>
                    <Alert text='Veuillez cocher les formations que vous voulez faire apparaitre sur cet entretien'/>
                    <List>
                        {allFormations.map(f => {
                                return <ListItem
                                    key={f.id}
                                    primaryText={f.nom_formation}
                                    hoverColor='red'
                                    secondaryTextLines={2}
                                    secondaryText={
                                        <p>{f.type}<br/>{f.initiateur + ' -- ' + moment(f.date_rea).format('ll')}
                                        </p>
                                    }
                                    rightAvatar={<Avatar style={{fontSize: 12}}>{f.duree} h</Avatar>}
                                    leftCheckbox={
                                        <Checkbox
                                            checked={f.validated}
                                            onCheck={(x, y) => this.handleFormationsValidation(f.id, y)}
                                        />
                                    }
                                />
                            }
                        )}

                    </List>
                    <RaisedButton
                        label="Ajouter une formation"
                        style={{marginTop: 15}}
                        onClick={() => this.setState({modalOpen: true})}
                        secondary={true}
                        icon={<AddIcon/>}
                    />
                    <Dialog
                        title="Ajout de formation"
                        modal={false}
                        open={this.state.modalOpen}
                        onRequestClose={() => this.setState({modalOpen: false})}
                        autoScrollBodyContent={true}
                    >
                        <FormationForm/>
                    </Dialog>
                </div>
            </div>

        );
    }
}

function mapStateToProps(store) {
    return {
        formations: store.entretien.formations,
        types_validation_formation: store.params.types_validation_formation,
        initiatives: store.params.initiatives,
        entretienHeader: store.entretien.header
    }
}

export default connect(mapStateToProps)(Page2);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/Page2.js